"use client"

import { fetchCategories } from "@/services/category"
import { ComponentConfig } from "@measured/puck"
import { message, Select } from "antd"
import { useEffect, useState } from "react"
import { filterOption } from "../../../../../../../lib/external-components"
import SelectBanner from "../../../components/SelectBanner"
import { RenderConfig } from "./RenderConfig"

export type CategoryBannerLayoutProps = {
  categoryId: string
  topBannerId: string
  bottomBannerId: string
  postsPerPage: number
}

const SelectCategory = ({ value, onChange }: any) => {
  const [options, setOptions] = useState<{ value: string; label: string }[]>([])

  const fetchCategoryOptions = async () => {
    try {
      const res = await fetchCategories()
      const items: Array<{ id: string; attributes: { name: string } }> = res?.data || []
      const categoryOptions = items.map(i => ({ value: String(i.id), label: i.attributes.name }))
      setOptions([{ value: "all", label: "All Categories" }, ...categoryOptions])
    } catch (e) {
      message.error("Không thể lấy danh mục")
    }
  }

  useEffect(() => {
    fetchCategoryOptions()
  }, [])

  const handleChange = (val: string) => {
    onChange(val === "all" ? "" : val)
  }

  const displayValue = value === "" || value === undefined ? "all" : value

  return (
    <Select
      showSearch
      placeholder="Chọn category"
      style={{ minWidth: "14rem" }}
      optionFilterProp="children"
      filterOption={filterOption}
      options={options}
      value={displayValue}
      onChange={handleChange}
    />
  )
}

export const CategoryBannerLayout = {
  label: "Tamda Media | CategoryBannerLayout",
  fields: {
    categoryId: {
      type: "custom",
      label: "Category",
      render: props => <SelectCategory {...props} />,
    },
    topBannerId: {
      type: "custom",
      label: "Top Banner",
      render: ({ value, onChange }) => (
        <SelectBanner placeholder="Chọn banner top" value={value} onChange={val => onChange(val ?? "")} />
      ),
    },
    bottomBannerId: {
      type: "custom",
      label: "Bottom Banner",
      render: ({ value, onChange }) => (
        <SelectBanner placeholder="Chọn banner bottom" value={value} onChange={val => onChange(val ?? "")} />
      ),
    },
    postsPerPage: {
      label: "Posts Per Page",
      type: "number",
      min: 1,
      max: 20,
    },
  },
  defaultProps: {
    categoryId: "",
    topBannerId: "",
    bottomBannerId: "",
    postsPerPage: 4,
  },
  ...RenderConfig,
} as ComponentConfig<CategoryBannerLayoutProps>
